import React from 'react';
import { IconSecuritySecure } from '@piggybank/core';

export const IconSecuritySecureHook = () => (
  <>
    {' '}
    <IconSecuritySecure inline={true} />{' '}
  </>
);
